import { defineFcm } from '../shared/factory';

export const FCM_DOUBLE_OPT_IN_ENABLED = defineFcm('double_opt_in_enabled').asBoolean().withDefault(false).toConfig();
